import { service } from '../utils/request';

export function seoView(uid) {
    return service({
        url: `/metatag/page/view?uid=${uid}`,
        method: 'get'
    });
}

export function seoUpdate(data) {
    return service({
        url: `/metatag/page/update`,
        method: 'post',
        data
    });
}
